import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { flagsmith } from '@common/Lib/Flagsmith';
import { buildProductTitle, getImageUrlWithSize } from '@common/Utility/common-utils';
import { CheckboxControl } from '@common/Component/Forms';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { IC_GREEN_TICK_DARK, PLUS_ICON, PRODUCT_CARD_DEFAULT } from '../../../../public/images';
import AddToCart from 'Epharmacy/Cart/AddToCart';
import { useRouter } from 'next/router';
import { dataLayerSendEvent, getProductItemObjectEventFillersSelect } from 'Epharmacy/EpharmacyAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getCurrency } from '@common/Constants/analytics';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';

const FBTProduct = ({ id, isFirstElement, link, image, title, price, previousPrice, handleCheckedItems, productInCart, cartData, parentSku, notInCart, newDataSet, setFbt_disabled, setShowUpselling,setFbt_addedtocart,pageId, screenName,referrerpage,product,index,pageType,sectionName, referrer_page = "" }) => {
  const generateURL = useNavigationURL();

  const fbtAddToCartData = useSelector((state) => state?.epharmacy?.FBTAddToCart?.data?.data);
  const [failedToCart, setFailedToCart] = useState(false);
  const [checked, setChecked] = useState(true);
  const [inCart, setInCart] = useState(false);
  const [src, setSrc] = useState(image);
  const [innerWidth, setInnerWidth] = useState(0);
  const router = useRouter();
  const ae_web_cartfillersConfig = flagsmith.getValue('ae_web_cartfillers', { json: true });
  const showEllipsisInTitle = ae_web_cartfillersConfig?.showEllipsisInTitle;

  React.useEffect(()=>{
    fbtAddToCartData?.failedToAdd.map((item_id) => {
      if(item_id === id) {
        setFailedToCart(true);
        setChecked(false);
        handleCheckedItems(id, false);
        setFbt_disabled(true);
      }
      return item_id;
    });

  },[fbtAddToCartData]);

  useEffect(() => {
    if(typeof window !== 'undefined') {
      setInnerWidth(window.innerWidth);
    }
  }, [window.innerWidth]);

  React.useEffect(() => {
    if(fbtAddToCartData?.failedToAdd.length > 0){
      if(!fbtAddToCartData?.failedToAdd.includes(id) && !failedToCart){
        setChecked(true);
        handleCheckedItems(id, true);
      }
    }else if(fbtAddToCartData?.failedToAdd.length === 0 && !failedToCart){
        setChecked(true);
        handleCheckedItems(id, true);
    }
  },[fbtAddToCartData]);

  const handleChange = (pid, checkState) => {
    setChecked(checkState);
    handleCheckedItems(pid, checkState);
  };

  useEffect(() => {
    cartData.some((element) => {
      if(element.sku === parentSku){ 
        setInCart(true); 
      }
    });
  },[cartData]);

  useEffect(() =>{
    if(productInCart !== '' || notInCart.length > 0){
      let cart = true;
       if(inCart && productInCart !== '' && id === parentSku){
        cart = false;
      }else if(notInCart.length > 0 && id === parentSku){
        cart = true;
      }
      if(id === parentSku){
        setChecked(cart);
        handleCheckedItems(parentSku, cart);
      }
    }
  }, [productInCart, notInCart, inCart]);

  const renderTitle = (content) => {
    const charPerRow = 16;
    return buildProductTitle({ content, showEllipsisInTitle, charPerRow }); 
  };

  return (
    <>
      {!isFirstElement && <div className="fbt-product-separator" style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
      <div className="plus-icon"> 
      <Image 
      src={PLUS_ICON} 
      alt="PLUS_ICON" 
      width={60}
      height={60}
       />
       </div> 
        </div>}
      <div 
      className={failedToCart? "fbt-product failedToAdd": "fbt-product"}
      
      >
        <div className='fbt_add'>
          <div className="fbt_checkbox">
            {isFirstElement ? (
              <Image src={IC_GREEN_TICK_DARK} alt="GREEN_TICK" />
            ) : (
              <CheckboxControl
                appVariant="epharmacy"
                checked={checked}
                onChange={(e) => handleChange(id, e.target.checked)}
              />
            )}
          </div>

          <Image
            onError={() => setSrc(PRODUCT_CARD_DEFAULT.src)}
            src={getImageUrlWithSize(src, 62, 62) || PRODUCT_CARD_DEFAULT.src}
            alt="product img"
            className="fbt_img"
            onClick={() =>{
                router.push(generateURL(link));
                dataLayerSendEvent('select_item', {
                  ecommerce: {
                    items: product ? [{ ...getProductItemObjectEventFillersSelect(product), index: index +1 }] : []
                  },
                  promotion_name:null,
                  promotion_value_tag: null,
                  section_name: "pdp upselling",
                  screen_name: screenName,
                  page_type: "product details page",
                  // page_id: page_id, // TODO: COMMENTED THIS AS IT'S NOT DEFINED
                  availability: product?.outOfStock  ? "out of stock" : "in stock",
                  express_availability:product?.express_bool? 'true' : 'false',
                  delivery_promise: product?.deliverByV2 || product?.deliverBy || null,
                  referrer_page: referrer_page ?? '',
                  myaster_category: 'epharmacy',
                  currency: getCurrency(getDataFromCookie('regionCode')),
                });
                sendEventToSmartLook('select_item');
                setShowUpselling(false);
              }}
            width="62px"
            height="62px"
            unoptimized
          />
          <p>{renderTitle(title)}</p>
          <div className="price-label">
            <span>{price}</span>
            {previousPrice !== null && <del>{previousPrice}</del>}
            </div>
            </div>
            <div className="add-to-card" >
              <AddToCart
                sku={newDataSet?.sku}
                availableStock={newDataSet?.quantity}
                product={newDataSet}
                outOfStock={!newDataSet?.inStock}
                isFirstElement={isFirstElement}
                minWidth={innerWidth <420 ? "110px" : "89px"}
                setFbt_addedtocart={setFbt_addedtocart}
                FBTProduct={true}
                pageId={pageId}
                screenName={screenName}
                referrerpage={referrerpage}
                pageType={pageType}
                sectionName={sectionName}
                enableFullWidth
                newButton={true}
              />
            </div>
      </div>
    </>
  );
};

FBTProduct.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  previousPrice: PropTypes.string,
  image: PropTypes.string,
  isFirstElement: PropTypes.bool,
  handleCheckedItems: PropTypes.func,
  link: PropTypes.string,
  productInCart: PropTypes.string,
  cartData: PropTypes.array,
  parentSku: PropTypes.string,
  notInCart: PropTypes.array,
  
};

FBTProduct.defaultProps = {
  previousPrice: '',
  image: '',
  isFirstElement: true,
  handleCheckedItems: () => {},
  link: '',
  productInCart: '',
  cartData: [],
  parentSku: '',
  notInCart: [],
};

export default FBTProduct;
